/* aminos-mens-buybox — page-scoped behaviour layered on top of
 * assets/aminos-featured-product.js, which is shared with ~15 other pages
 * and is deliberately left untouched.
 *
 * Sole job: keep each option card's quantity-dependent copy in step with
 * the selector.
 *
 *   - Pack count: choosing quantity 2 turns "28 packs, every 4 weeks" into
 *     "56 packs, every 4 weeks". The forked snippet renders the number
 *     into its own [data-mns-packs] span and stashes the per-unit count
 *     on data-mns-pack-base, so this file only ever multiplies that
 *     base — it never parses or rewrites the merchant's copy around it.
 *
 *   - Per-day qualifier: the per-day figure is deliberately NOT scaled
 *     (it is one person's daily cost, so two units is still $1.28 each,
 *     not $2.56 — the shared script makes the same call). Since the pack
 *     count beside it does scale, the "| Per Person" span is revealed once
 *     more than one unit is selected so the two can't be misread against
 *     the doubled total.
 *
 *   - Multi-adult bonus: when the form carries data-mns-bundle-min and
 *     the quantity reaches it, the subscription price, per-day figure,
 *     banner, offer title and discount note switch to their bonus versions
 *     (all rendered by the snippet as data-mns-base / data-mns-bundle, so
 *     this file never formats money or copy itself). The price works by
 *     swapping the element's fpBase, the unit price the shared script
 *     multiplies by quantity, so the shared script scales the right figure
 *     whichever of the two handlers runs last. The checkout script picks the
 *     matching discount code.
 *
 * Loaded only by sections/aminos-mens-buybox.liquid.
 *
 * Copied from the aminos-nutrition-support-* set (/pages/nutrition-support):
 * same code, mens copy and images.
 */
(function (global) {
  'use strict';

  if (global.__aminosMenBuyboxInit) return;
  global.__aminosMenBuyboxInit = true;

  var SCOPE = '.aminos-mens-buybox';

  function quantityOf(form) {
    var field =
      form.querySelector('input[name="quantity"]:checked') ||
      form.querySelector('input[name="quantity"]');
    return Math.max(1, parseInt((field && field.value) || '1', 10) || 1);
  }

  // Same maths as scaleMoney in the shared aminos-featured-product.js:
  // multiply the first number in a money string, keeping symbol and decimals.
  function scaleMoney(text, qty) {
    return text.replace(/[\d.,]+/, function (token) {
      var dot = token.lastIndexOf('.');
      var decimals = dot === -1 ? 0 : token.length - dot - 1;
      var value = parseFloat(token.replace(/,/g, ''));
      if (isNaN(value)) return token;
      return (value * qty).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    });
  }

  function refreshBundle(form, qty) {
    var min = parseInt(form.dataset.mnsBundleMin, 10);
    if (!min) return;
    var bundle = qty >= min;

    form.querySelectorAll('[data-mns-bundle-price]').forEach(function (el) {
      var unit = bundle ? el.dataset.mnsBundlePrice : el.dataset.mnsBasePrice;
      el.dataset.fpBase = unit;
      el.textContent = scaleMoney(unit, qty);
    });

    form.querySelectorAll('[data-mns-swap]').forEach(function (el) {
      el.textContent = bundle ? el.dataset.mnsBundle : el.dataset.mnsBase;
    });
  }

  function refreshQuantityCopy(form) {
    var qty = quantityOf(form);
    refreshBundle(form, qty);

    form.querySelectorAll('[data-mns-packs]').forEach(function (el) {
      var base = parseInt(el.getAttribute('data-mns-pack-base'), 10);
      if (!base) return;
      el.textContent = base * qty;
    });

    form.querySelectorAll('.aminos-mens-buybox__per-unit').forEach(function (el) {
      el.hidden = qty < 2;
    });
  }

  function refreshAll() {
    document.querySelectorAll(SCOPE + ' [data-aminos-fp-form]').forEach(refreshQuantityCopy);
  }

  // Delegated, matching how the shared script binds — survives the theme
  // editor swapping section markup out from under us.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var qtyRadio = target.closest('[data-aminos-fp-qty]');
    if (!qtyRadio) return;
    var form = qtyRadio.closest('[data-aminos-fp-form]');
    if (form && form.closest(SCOPE)) refreshQuantityCopy(form);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  document.addEventListener('shopify:section:load', refreshAll);
})(window);
